export default __webpack_public_path__ + "static/media/ST.9bb63ab3.svg";